var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20259 13.7903L7.2968 13.7071L14.0039 7L7.2968 0.292893C6.90628 -0.0976311 6.27311 -0.0976312 5.88259 0.292893C5.5221 0.653377 5.49437 1.22061 5.7994 1.6129L5.88259 1.70711L10.1737 6L-0.000306384 6L-0.000306559 8L10.1757 8L5.88259 12.2929C5.5221 12.6534 5.49437 13.2206 5.7994 13.6129L5.88259 13.7071C6.24307 14.0676 6.8103 14.0953 7.20259 13.7903Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.30a9f94e.svg";
export { ForwardRef as ReactComponent };